import { Clipboard } from '@angular/cdk/clipboard';
import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { faClipboardCheck, faLink } from '@fortawesome/free-solid-svg-icons';

import { Blog } from '../../../shared/data/models/collections/blog';
import { Request } from '../../../shared/data/services/request-enum';
import { AbstractLocalizedComponent } from '../../../shared/ui/abstract.localized.component';

@Component({
  selector: 'placeme-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss'],
})
export class BlogComponent extends AbstractLocalizedComponent {
  blog: Blog;
  faLink = faLink;
  faLinkedinIn = faLinkedinIn;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private activatedRoute: ActivatedRoute,
    private clipboard: Clipboard
  ) {
    super();
  }

  currentUrl(): string {
    return this.document.location.href;
  }

  shareLinkedinUrl(): string {
    const url = encodeURIComponent(this.currentUrl());
    const title = encodeURIComponent(this.blog?.seo.title);
    const summary = encodeURIComponent(this.blog?.seo.description);
    const domain = encodeURIComponent(this.document.location.host);
    return `http://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}&summary=${summary}&source=${domain}`;
  }

  toClipBoard(): void {
    this.clipboard.copy(this.currentUrl());
    this.faLink = faClipboardCheck;
    setTimeout(() => (this.faLink = faLink), 2000);
  }

  protected loadData(locale: string): void {
    this.collectionsService
      .query<{ blogBySlug: Blog }>(Request.BLOG, {
        slug: this.activatedRoute.snapshot.params.slug,
        locale,
      })
      .subscribe(data => (this.blog = data.blogBySlug));
  }
}
